import { asText } from '../../../../components/NaturaOps/JsonBlock'
import { formatTimestamp } from '../../../../components/NaturaOps/formatTimestamp'

// Re-exported: the picking screen needs the same format, and both paste into Natura tickets.
export { formatTimestamp }

const DASH = '—'

// One pasteable block for the Natura ticket. The operator should never have to
// copy four fields and two payloads separately and reassemble them by hand.
export const buildTicketText = (data, t) => {
  const label = key => t(`natura_operations.confirmation_resend.${key}`)
  const confirmedAt = formatTimestamp(data.externally_confirmed_at)

  const lines = []

  // Without the verdict a refusal pastes as a success: Natura still received the
  // POST, so `delivery` alone reads "Chegou na SAP" with nothing saying it failed.
  // The platform's `message` is deliberately not copied: on the no-response path
  // it is a raw Ruby exception string, and this block leaves Cubbo.
  if (data.delivery || data.error) {
    lines.push(label(data.error ? `outcome_${data.error}` : 'outcome_accepted'), '')
  }

  lines.push(
    `${label('field_replenishment_id')}: ${data.replenishment_id ?? DASH}`,
    `${label('field_external_reference')}: ${data.external_reference || DASH}`,
    `${label('field_store')}: ${data.store_name || DASH}${data.store_id ? ` (id ${data.store_id})` : ''}`,
    `${label('field_confirmed_at')}: ${confirmedAt || label('never_confirmed')}`,
    `${label('field_path')}: ${data.request?.path || DASH}`,
  )

  if (data.delivery) {
    lines.push(`${label('field_delivery')}: ${label(`delivery_${data.delivery}`)}`)
  }

  lines.push('', `--- ${label('request_heading')} ---`, asText(data.request?.body) || DASH)

  if (data.response) {
    const code = data.response.code ? ` (HTTP ${data.response.code})` : ''
    lines.push('', `--- ${label('response_heading')}${code} ---`, asText(data.response.body) || label('response_empty'))
  }

  return lines.join('\n')
}
